import React from 'react';
export var ProjectStateContext = React.createContext({
    hideNAItems: false,
    showRedDotDeliverable: false,
    isProjectTerminatedOrCompleted: false
});
